/** Group a numeric price with he-IL thousands separators. The ₪ glyph is
 *  rendered separately (different font size), so this returns digits only. */
export const formatPrice = (value: number): string =>
  Number.isFinite(value) ? value.toLocaleString("he-IL") : ""
